<script>
  import SortDirection from "./SortDirection.svelte";
  import { fade } from "svelte/transition";
  import { push } from "svelte-spa-router";
  import { factoryStore } from "../store/factories.js";
  import * as SharedComponents from "../SharedComponents/index.js";
  import { getContext } from "svelte";
  import { langTextStore } from "../store/langtexts.js";
  import IconDelete from "../Vectors/delete.svelte";
  import IconCopy from "../Vectors/copy.svelte";
  import IconDownload from "../Vectors/download.svelte";
  import IconEdit from "../Vectors/edit.svelte";
  import { inputVariableStore } from "../store/inputVariables.js";

  import Copy from "../Vectors/copy.svelte";
  import Confirm from "../SharedComponents/Confirm.svelte";
  import Prompt from "../SharedComponents/Prompt.svelte";
  export let factorySettingId = null;
  const { open } = getContext("modal");
  const { snackbar } = getContext("app");
  function addProduct() {
    if (factorySettingId != null) {
      push("/createproduct/" + factorySettingId + "?fromfactory=true");
      return;
    }
    push("#/createproduct");
  }
  let numRecords = 50;

  let sortElement = "changeDate";
  let sortDirection = -1;

  let loading = false;
  function moreRecords() {
    numRecords += 50;
  }
  let searchFilter = "";
  $: debounceFindProducts(
    searchFilter,
    numRecords,
    sortElement,
    sortDirection,
    lastChange
  );
  async function downloadProduct(product) {
    await factoryStore.downloadProduct(product.uuid);
  }
  let lastChange = -1;
  $: setLastChange($factoryStore.lastSyncDate);
  function setLastChange(lastChangeInternal) {
    if (lastChangeInternal != lastChange) {
      lastChange = lastChangeInternal;
    }
  }

  let firstTimeAround = true;
  let timer = null;
  function debounceFindProducts(
    searchFilter,
    numRecords,
    sortElement,
    sortDirection,
    changedate
  ) {
    if (firstTimeAround) {
      firstTimeAround = false;
      findProducts(
        searchFilter,
        numRecords,
        sortElement,
        sortDirection,
        factorySettingId,
        changedate
      );
      return;
    }
    clearTimeout(timer);
    timer = setTimeout(async () => {
      findProducts(
        searchFilter,
        numRecords,
        sortElement,
        sortDirection,
        factorySettingId,
        changedate
      );
    }, 600); /// this is the debounce pattern
  }
  let filteredProducts = [];
  let totalFilteredProducts = 0;
  async function findProducts(
    searchFilter,
    numRecords,
    sortElement,
    sortDirection,
    factorySettingId,
    changedate
  ) {
    loading = true;
    var ret = await factoryStore.findProducts(
      searchFilter,
      numRecords,
      sortElement,
      sortDirection,
      factorySettingId
    );
    for (var productIndex in ret.filteredProducts) {
      var product = ret.filteredProducts[productIndex];
      product.factory = await factoryStore.getFactoryAndVersionName(
        product.factorySettingId
      );
    }
    filteredProducts = ret.filteredProducts;
    totalFilteredProducts = ret.totalFilteredProducts;
    loading = false;
  }
  $: hasMoreProducts = filteredProducts.length < totalFilteredProducts;

  function openProductSettings(product) {
    push("/");
    window.setTimeout(() => {
      push("/calculator/product/" + product.uuid, {
        returnUrl: "/dashboard/products",
      });
    }, 200);
  }

  function setSorting(sortingType) {
    if (sortElement == sortingType) {
      sortDirection = sortDirection * -1;
    } else {
      sortDirection = "1";
      sortElement = sortingType;
    }
  }

  async function copyProduct(product) {
    open(Prompt, {
      confirmAction: async (name) => {
        var newId = await factoryStore.copyProduct(product.uuid, name);
        findProducts(searchFilter, numRecords, sortElement, sortDirection);
        snackbar("info", "product copied");
      },
      inputVal:
        product.name +
        " (" +
        $langTextStore.getText("general-label-copy") +
        " )",
      actionButtonTextOverrideLangKey: "general-label-copy",
      cancelButtonTextOverrideLangKey: "general-label-cancel",
      titleLangKey: "general-copy-product-name",
      contentLangKey: "general-enter-name-for-new-product",
    });
  }
  async function deleteProduct(product) {
    open(Confirm, {
      confirmAction: async () => {
        await factoryStore.deleteProduct(product);
        findProducts(
          searchFilter,
          numRecords,
          sortElement,
          sortDirection,
          factorySettingId
        );
      },
      actionButtonTextOverrideLangKey: "general-label-delete-now",
      cancelButtonTextOverrideLangKey: "general-label-cancel",
      titleLangKey: "general-are-you-sure-delete-product-setting-title",
      contentLangKey: "general-are-you-sure-delete-product-setting-content",
    });
  }
</script>

{#if !(window.location.href.indexOf("factorysettings") > 0) || $inputVariableStore.safeToNavigate}
  <div class="row g-0 px-5">
    {#if factorySettingId == null}
      <div class="col-12 col-md-7 mb-3">
        <h2 class="intro">
          {@html $langTextStore.getText("general-text-create-or-edit-products")}
        </h2>
        {@html $langTextStore.getText(
          "general-text-create-or-edit-products-intro"
        )}
      </div>
    {/if}
    <div class="col-6 list-head">
      <button
        class="btn btn-primary px-4 mt-5 mb-4 w-auto float-start"
        on:click={addProduct}
        >{$langTextStore.getText("general-labels-add-product")}
      </button>
    </div>
    <div class="col-6 list-head text-right">
      <input
        type="text"
        class="search me-3 mt-5 mb-4"
        placeholder={$langTextStore.getText("general-labels-search")}
        bind:value={searchFilter}
      />
    </div>
    <div class="col-12 list-main">
      <div class="list-main__item row g-0">
        <div
          class="col-12 col-md-3 font-weight-bold text-gray-5 c-pointer"
          on:click={() => {
            setSorting("name");
          }}
        >
          {$langTextStore.getText("general-label-name")}
          <SortDirection
            selectedSortElement={sortElement}
            selectedSortDirection={sortDirection}
            sortElement="name"
          />
        </div>
        <div
          class="d-none d-md-flex col-2 font-weight-bold text-gray-5 c-pointer"
          on:click={() => {
            setSorting("brand");
          }}
        >
          {$langTextStore.getText("general-label-brand")}
          <SortDirection
            selectedSortElement={sortElement}
            selectedSortDirection={sortDirection}
            sortElement="brand"
          />
        </div>
        <div
          class="d-none d-md-flex col-1 font-weight-bold text-gray-5 c-pointer"
          on:click={() => {
            setSorting("style");
          }}
        >
          {$langTextStore.getText("general-label-style")}
          <SortDirection
            selectedSortElement={sortElement}
            selectedSortDirection={sortDirection}
            sortElement="style"
          />
        </div>
        <div
          class="d-none d-md-flex col-2 font-weight-bold text-gray-5 c-pointer"
          on:click={() => {
            setSorting("factory");
          }}
        >
          {$langTextStore.getText("general-label-factory")}
          <SortDirection
            selectedSortElement={sortElement}
            selectedSortDirection={sortDirection}
            sortElement="factory"
          />
        </div>
        <div
          class="d-none d-md-flex col-2 font-weight-bold text-gray-5 c-pointer"
          on:click={() => {
            setSorting("country");
          }}
        >
          {$langTextStore.getText("general-label-country")}
          <SortDirection
            selectedSortElement={sortElement}
            selectedSortDirection={sortDirection}
            sortElement="country"
          />
        </div>
        <div
          class="d-none d-md-flex col-1 font-weight-bold text-gray-5 c-pointer"
          on:click={() => {
            setSorting("changeDate");
          }}
        >
          {$langTextStore.getText("general-label-date-created")}
          <SortDirection
            selectedSortElement={sortElement}
            selectedSortDirection={sortDirection}
            sortElement="changeDate"
          />
        </div>
        {#if !loading}
          <div class="col-12 list" in:fade>
            {#each filteredProducts as product}
              <div
                class="row gx-0 py-0 row-with-default-button"
                on:click={openProductSettings(product)}
              >
                <div class="col-13 col-md-3 px-0 py-1">
                  {product.name}
                </div>
                <div class="col-3 col-md-2 px-0 py-1">
                  {product.brand}
                </div>
                <div class="col-2 col-md-1 px-0 py-1">
                  {product.style}
                </div>
                <div class="col-3 col-md-2 px-0 py-1">
                  {product.factory}
                </div>
                <div class="col-1 col-md-2 px-0 py-1">
                  {product.country}
                </div>
                <div class="col-2 col-md-1 px-0 py-1">
                  <SharedComponents.Date date={product.changeDate} />
                </div>
                <div
                  class="col-3 col-md-3 text-right px-0 py-1 cancel-default-focus"
                  on:click|preventDefault|stopPropagation
                >
                  <IconDelete
                    on:click={deleteProduct(product)}
                    icontitle={$langTextStore.getText(
                      "general-label-delete-product"
                    )}
                  />
                  <IconCopy
                    on:click={copyProduct(product)}
                    icontitle={$langTextStore.getText(
                      "general-label-make-a-copy-product"
                    )}
                  />
                  <IconDownload
                    on:click={downloadProduct(product)}
                    icontitle={$langTextStore.getText(
                      "general-label-download-product"
                    )}
                  />

                  <IconEdit
                    on:click={openProductSettings(product)}
                    icontitle={$langTextStore.getText(
                      "general-label-edit-product"
                    )}
                  />
                </div>
              </div>
            {/each}
            {#if hasMoreProducts}
              <div
                class="btn btn-primary btn--open width-unset mt-5"
                on:click={moreRecords}
              >
                {$langTextStore.getText("general-label-load-more")}
              </div>
            {/if}
          </div>
        {/if}
        <hr class="mt-3" />
      </div>
    </div>
    <div class="col-12 col-md-7 mt-2 mb-5 text-small">
      {$langTextStore.getText("general-footer-text")}
    </div>
    <div class="mb-5">
      <a href="privacy.pdf" style="font-size:.8rem;">
        {$langTextStore.getText("general-privacy-statement")}</a
      >
      -
      <a href="terms.pdf" style="font-size:.8rem;">
        {$langTextStore.getText("general-terms")}</a
      >
    </div>
  </div>
{:else}
  Please wait while saving
{/if}
